module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '广告ID',
      value: 'id',
    },
    {
      name: '广告名称',
      value: 'name',
    },
    {
      name: '投放平台',
      format: (row) => {
        const { delivery_platform_type } = row;
        return s.enum_map.delivery_platform_type[delivery_platform_type];
      },
    },
    {
      name: '广告版位',
      format: (row) => {
        const { site_set_type = 1, site_sets = [] } = row;
        return site_set_type === 1 ? '自动版位' : site_sets.map(site_set => s.enum_map.site_sets[site_set]).join('、');
      },
    },
    {
      name: '创建时间',
      value: 'created_time',
    },
  ];
};
